export class BoundingBox {
  xl: number;
  xr: number;
  yt: number;
  yb: number;
}
